import {FC} from "react";
import {Col, Container, Navbar, Row} from "react-bootstrap";
import appLogo from "../../../assets/images/right_rental_logo.png";

interface Props {}

const AppFooter: FC<Props> = (props) => {
    return <Navbar fixed="bottom" className={"app-footer"}>
        <Container fluid>
            <Row className={"w-100 justify-content-center align-content-center"}>
                <Col xs={"auto"}>
                    <span>v 1.1.01 :: 12.2025</span>
                </Col>
            </Row>
        </Container>
    </Navbar>
}

export default AppFooter;
